import searchIcon from './searchIcon.png'

const Icons = {
    searchIcon
}

export default Icons